module.exports = __webpack_public_path__ + "static/img/12.148f411.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/12.jpg
// module id = jzl1
// module chunks = 1